
export default{ 
    accountNumber: 'Account number',//英文
    home:'Home',
    ProjectSite:'Project site',
    notice:'Notice',
    UserRights:'User rights',
    whole:'whole',
    onLine:'on line',
    offLine:'off line',
    serialNumber:'serial number',
    GatewayName:'Gateway Name',
    PleaseinputGatewayName:'Please input Gateway Name',
    PleaseinputserialNumber:'Please input serial Number',
    newlyAdded:'newly added',
    Import:'Import',
    export:'export',
    DisplayColumns:'Display columns',
    Submit:'Submit',
    AlarmEvent:'Alarm event',
    systemLog:'system log',
    Unread:'Unread',
    Read:'Read'
}  